import React from 'react';
import { Preview, PreviewWrapper, ZoomWrapper, PanOverlay } from './style';
import { ZoomIn, ZoomOut } from 'components/pspdf/style';
import { Position } from 'types';

function ImagePreview({ url }) {
  const [pan, setPan] = React.useState<Position>({ x: 0, y: 0 });
  const [start, setStart] = React.useState<Position | undefined>(undefined);
  const [zoom, setZoom] = React.useState(1);

  function zoomIn() {
    setZoom(zoom + 0.25);
  }

  function zoomOut() {
    const scale = Math.max(zoom - 0.25, 1);

    setZoom(scale);

    if (scale === 1) {
      setPan({ x: 0, y: 0 });
    }
  }

  function panTo(event) {
    if (event.buttons === 1) {
      const origin = event.target.getBoundingClientRect();
      const current = { top: event.clientY, left: event.clientX };
      const relative = {
        x: current.left - origin.x,
        y: current.top - origin.y,
      };

      if (start) {
        const updated = {
          x: relative.x - origin.width * start.x,
          y: relative.y - origin.height * start.y,
        };

        setPan(updated);
      } else {
        setStart({
          x: (relative.x - pan.x) / origin.width,
          y: (relative.y - pan.y) / origin.height,
        });
      }
    }
  }

  const style = {
    top: pan.y,
    left: pan.x,
    transform: `scale(${zoom})`,
  };

  return (
    <>
      <PreviewWrapper>
        <PanOverlay
          onMouseMove={panTo}
          onMouseUp={() => {
            setStart(undefined);
          }}
          style={{ cursor: start ? 'grabbing' : 'grab' }}
        />
        <Preview src={url} style={style} />
      </PreviewWrapper>
      <ZoomWrapper>
        <ZoomIn onClick={zoomIn} />
        <ZoomOut onClick={zoomOut} />
      </ZoomWrapper>
    </>
  );
}

export default ImagePreview;
